/* eslint-disable react/require-default-props */
import { ReactNode } from 'react';

export type TdProps = {
  children: ReactNode;
  width?: string;
  colSpan?: number;
  rowSpan?: number;
};
const Td: React.FC<TdProps> = ({ children, width, colSpan, rowSpan }) => {
  return (
    <td
      style={{
        width: `${width}`,
        border: '1px solid #CDCFD1',
        verticalAlign: 'middle',
      }}
      className="px-4 py-2 text-center"
      colSpan={colSpan}
      rowSpan={rowSpan}
    >
      {children}
    </td>
  );
};

export default Td;
